import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "wabuilder-card" }
const _hoisted_2 = { class: "wabuilder-header" }
const _hoisted_3 = { class: "wabuilder-header-title" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-6" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = { class: "wabuilder-label" }
const _hoisted_8 = { class: "wabuilder-select-wrap" }
const _hoisted_9 = { value: "button" }
const _hoisted_10 = { value: "list" }
const _hoisted_11 = { value: "location_request_message" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_14 = { class: "wabuilder-section-header" }
const _hoisted_15 = { class: "wabuilder-label wabuilder-label--inline" }
const _hoisted_16 = { class: "wabuilder-counter" }
const _hoisted_17 = { class: "wabuilder-cols-head" }
const _hoisted_18 = { class: "wabuilder-btn-rows" }
const _hoisted_19 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_20 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  class: "text-danger small mb-2"
}
const _hoisted_23 = {
  key: 1,
  class: "mb-3"
}
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = { class: "wabuilder-label" }
const _hoisted_26 = ["placeholder"]
const _hoisted_27 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_28 = { class: "wabuilder-counter wabuilder-counter--block" }
const _hoisted_29 = { class: "wabuilder-label" }
const _hoisted_30 = { class: "wabuilder-list-rows" }
const _hoisted_31 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_32 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_33 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = {
  key: 0,
  class: "text-danger small mb-2"
}
const _hoisted_36 = { class: "col-md-6" }
const _hoisted_37 = { class: "wabuilder-label" }

import { onMounted, ref, watch, computed } from 'vue';
import InteractiveMessagePreview from './InteractiveMessagePreview.vue';
import WhatsAppPhonePreview from './WhatsAppPhonePreview.vue';
import { Interactive } from '@/types/Interactive';
import TextEditor from './TextEditor.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'InteractiveMessageBuilder',
  props: {
    selectedInteractive: {}
  },
  emits: ['interactiveUpdated'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit
const props = __props
const formattedMessage = ref<string>('')
const message = ref<Interactive>({
  type: 'button',
  body: { text: '' },
  action: {
    buttons: [],
  },
});

// Computed properties for button text validation
const buttonTextLength = computed(() => {
  return message.value.action.button?.length || 0;
});

const isButtonTextInvalid = computed(() => {
  return buttonTextLength.value > 20;
});

// Button title validation functions
const isButtonTitleInvalid = (title: string) => {
  return title.length > 20;
};

const hasInvalidButtonTitles = computed(() => {
  return message.value.action.buttons?.some(button =>
    isButtonTitleInvalid(button.reply?.title || '')
  ) || false;
});

// List item title validation
const isListItemTitleInvalid = (title: string) => {
  return title.length > 24;
};

// List item description validation
const isListItemDescriptionInvalid = (description: string) => {
  return description.length > 72;
};

const hasInvalidListItems = computed(() => {
  const rows = getListRows();
  return rows.some(row =>
    isListItemTitleInvalid(row.title || '') ||
    isListItemDescriptionInvalid(row.description || '')
  );
});

watch(message, (newMessage) => {
  emit('interactiveUpdated', newMessage)
}, { deep: true });

// Watch for type changes to initialize proper structure
watch(() => message.value.type, (newType) => {
  if (newType === 'list') {
    ensureDefaultSection();
    if (!message.value.action.button) {
      message.value.action.button = '';
    }
  } else if (newType === 'button') {
    if (!message.value.action.buttons) {
      message.value.action.buttons = [];
    }
  }
});

function updateFormattedMessage(text: string): void{
  formattedMessage.value = text
}

function updateMessage(text: string): void{
  message.value.body = {
    text: text,
  }
}

function addButton() {
  message.value.action.buttons?.push({
    type: 'reply',
    reply: {
      id: '',
      title: '',
    },
  });
  emit('interactiveUpdated', message.value)
}

function removeButton(index: number) {
  message.value.action.buttons?.splice(index, 1);
  emit('interactiveUpdated', message.value)
}

// List management functions (working with single default section)
function getListRows() {
  ensureDefaultSection();
  return message.value.action.sections?.[0]?.rows || [];
}

function ensureDefaultSection() {
  if (!message.value.action.sections) {
    message.value.action.sections = [];
  }
  if (message.value.action.sections.length === 0) {
    message.value.action.sections.push({
      rows: []
    });
  }
}

function addRow() {
  ensureDefaultSection();
  message.value.action.sections![0].rows.push({
    id: '',
    title: '',
    description: ''
  });
  emit('interactiveUpdated', message.value)
}

function removeRow(index: number) {
  ensureDefaultSection();
  message.value.action.sections![0].rows.splice(index, 1);
  emit('interactiveUpdated', message.value)
}

onMounted(() => {
  const defaultMessage: Interactive = {
    type: 'button',
    body: { text: '' },
    action: {
      buttons: [],
    },
  };

  if (props.selectedInteractive) {
    message.value = { ...props.selectedInteractive };
    // Ensure proper structure for list messages
    if (message.value.type === 'list') {
      ensureDefaultSection();
    }
  } else {
    message.value = defaultMessage;
  }

  emit('interactiveUpdated', message.value)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "wabuilder-header-icon" }, [
        _createElementVNode("em", { class: "fas fa-bolt" })
      ], -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('wp.titles.interactive_message')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('wp.placeholders.message_type')), 1),
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("select", {
              class: "wabuilder-select",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((message.value.type) = $event))
            }, [
              _createElementVNode("option", _hoisted_9, _toDisplayString(_ctx.$t('wp.fields.button')), 1),
              _createElementVNode("option", _hoisted_10, _toDisplayString(_ctx.$t('wp.fields.list')), 1),
              _createElementVNode("option", _hoisted_11, _toDisplayString(_ctx.$t('wp.fields.location_request')), 1)
            ], 512), [
              [_vModelSelect, message.value.type]
            ]),
            _cache[3] || (_cache[3] = _createElementVNode("em", { class: "fas fa-chevron-down wabuilder-select-caret" }, null, -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(TextEditor, {
            selectedMessage: message.value.body?.text ?? '',
            onContentUpdated: updateFormattedMessage,
            onMessageUpdated: updateMessage
          }, null, 8, ["selectedMessage"])
        ]),
        (message.value.type === 'button')
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('wp.fields.reply_buttons_label')), 1),
                _createElementVNode("span", _hoisted_16, _toDisplayString(message.value.action.buttons?.length ?? 0) + "/3", 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('wp.fields.column_label')), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('wp.fields.column_action_id')), 1),
                _cache[4] || (_cache[4] = _createElementVNode("span", null, null, -1))
              ]),
              _createElementVNode("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(message.value.action.buttons, (button, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "wabuilder-btn-row"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: _normalizeClass(["wabuilder-input wabuilder-input--sm", { 'is-invalid': isButtonTitleInvalid(button.reply?.title || '') }]),
                      "onUpdate:modelValue": ($event: any) => ((button.reply!.title) = $event),
                      placeholder: _ctx.$t('wp.placeholders.button_label'),
                      maxlength: "20"
                    }, null, 10, _hoisted_19), [
                      [_vModelText, button.reply!.title]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      class: "wabuilder-input wabuilder-input--sm wabuilder-input--mono",
                      "onUpdate:modelValue": ($event: any) => ((button.reply!.id) = $event),
                      placeholder: _ctx.$t('wp.placeholders.button_action')
                    }, null, 8, _hoisted_20), [
                      [_vModelText, button.reply!.id]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "wabuilder-delete-btn",
                      onClick: ($event: any) => (removeButton(index))
                    }, [...(_cache[5] || (_cache[5] = [
                      _createElementVNode("em", { class: "fas fa-trash" }, null, -1)
                    ]))], 8, _hoisted_21)
                  ]))
                }), 128))
              ]),
              (hasInvalidButtonTitles.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_ctx.$t('wp.validations.button_title_max_length')), 1))
                : _createCommentVNode("", true),
              ((message.value.action.buttons?.length ?? 0) < 3)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "wabuilder-add-btn",
                    onClick: addButton
                  }, [
                    _cache[6] || (_cache[6] = _createElementVNode("em", { class: "fas fa-plus" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('wp.actions.add_button')), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (message.value.type === 'list')
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('wp.fields.button_text')), 1),
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["wabuilder-input", { 'is-invalid': isButtonTextInvalid.value }]),
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((message.value.action.button) = $event)),
                  placeholder: _ctx.$t('wp.placeholders.button_text'),
                  maxlength: "20"
                }, null, 10, _hoisted_26), [
                  [_vModelText, message.value.action.button]
                ]),
                (isButtonTextInvalid.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.$t('wp.validations.button_text_max_length')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_28, _toDisplayString(buttonTextLength.value) + "/20 " + _toDisplayString(_ctx.$t('wp.fields.characters')), 1)
              ]),
              _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('wp.fields.list_items')), 1),
              _createElementVNode("div", _hoisted_30, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getListRows(), (row, rowIndex) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: rowIndex,
                    class: "wabuilder-list-row"
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      class: "wabuilder-input wabuilder-input--sm",
                      "onUpdate:modelValue": ($event: any) => ((row.id) = $event),
                      placeholder: _ctx.$t('wp.placeholders.item_id')
                    }, null, 8, _hoisted_31), [
                      [_vModelText, row.id]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      class: _normalizeClass(["wabuilder-input wabuilder-input--sm", { 'is-invalid': isListItemTitleInvalid(row.title || '') }]),
                      "onUpdate:modelValue": ($event: any) => ((row.title) = $event),
                      placeholder: _ctx.$t('wp.placeholders.item_title'),
                      maxlength: "24"
                    }, null, 10, _hoisted_32), [
                      [_vModelText, row.title]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      class: _normalizeClass(["wabuilder-input wabuilder-input--sm", { 'is-invalid': isListItemDescriptionInvalid(row.description || '') }]),
                      "onUpdate:modelValue": ($event: any) => ((row.description) = $event),
                      placeholder: _ctx.$t('wp.placeholders.item_description'),
                      maxlength: "72"
                    }, null, 10, _hoisted_33), [
                      [_vModelText, row.description]
                    ]),
                    _createElementVNode("button", {
                      type: "button",
                      class: "wabuilder-delete-btn",
                      onClick: ($event: any) => (removeRow(rowIndex))
                    }, [...(_cache[7] || (_cache[7] = [
                      _createElementVNode("em", { class: "fas fa-trash" }, null, -1)
                    ]))], 8, _hoisted_34)
                  ]))
                }), 128))
              ]),
              (hasInvalidListItems.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.$t('wp.validations.list_items_max_length')), 1))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "button",
                class: "wabuilder-add-btn",
                onClick: addRow
              }, [
                _cache[8] || (_cache[8] = _createElementVNode("em", { class: "fas fa-plus" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('wp.actions.add_item')), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('common.fields.label_preview')), 1),
        _createVNode(WhatsAppPhonePreview, null, {
          default: _withCtx(() => [
            _createVNode(InteractiveMessagePreview, {
              message: message.value,
              formattedMessage: formattedMessage.value
            }, null, 8, ["message", "formattedMessage"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})